import React from "react";

export function AboutSection() {
  return (
    <section className="section section-alt">
      <div className="section-inner about-layout">
        <div className="about-copy">
          <header className="section-header section-header-left">
            <p className="section-eyebrow">O nama</p>
            <h2 className="section-title">Priča RESTORANA KRČMA</h2>
          </header>
          <p>
            RESTORAN KRČMA objedinjuje restoran nacionalne hrane, toplu banket salu za sve
            vrste proslava i udoban smeštaj za goste. Zamislili smo mesto gde se autentična
            domaća kuhinja, iskreno gostoprimstvo i rustičan ambijent prirodno susreću.
          </p>
          <p>
            Akcenat stavljamo na kvalitet hrane, kvalitet usluge i ljubaznost osoblja. Bilo
            da dolazite na ručak, intimno slavlje ili veliko venčanje, naš je zadatak da vas
            dočekamo sa osmehom i da se pobrinemo da sve protekne bez brige.
          </p>
          <p>
            Verujemo u iskreno gostoprimstvo, toplu reč i pažnju prema
            detaljima – od prvog pozdrava na ulazu do poslednje šoljice
            domaće kafe.
          </p>
          <div className="about-signature">
            <span className="about-name">RESTORAN KRČMA</span>
            <span className="about-role">Vaša domaćinska kuća van kuće</span>
          </div>
        </div>
        <div className="about-sidecard">
          <h3>Zašto gosti biraju nas</h3>
          <ul className="feature-list">
            <li>Autentičan etno ambijent bez kiča</li>
            <li>Generacijama provereni recepti</li>
            <li>Fleksibilna organizacija proslava</li>
            <li>Mogućnost smeštaja u sklopu objekta</li>
            <li>Pristupačna lokacija i parking</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

